import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Component, OnInit, ViewEncapsulation, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { fadeInRightAnimation } from 'src/@fury/animations/fade-in-right.animation';
import { fadeInUpAnimation } from 'src/@fury/animations/fade-in-up.animation';
import { scaleInAnimation } from 'src/@fury/animations/scale-in.animation';
import { Confirmation } from 'src/app/enums/confirmation.enum';
import { ErrorText } from 'src/app/enums/error-text.enum';
import { ErrorType } from 'src/app/enums/error-type.enum';
import { ApiService } from 'src/app/services/api.service';
import { ContentActionComponent } from 'src/app/shared/content-action/content-action.component';
import { FormControl, FormGroup } from '@angular/forms';
import { FilterFormModal, FilterValue } from 'src/app/models/form-group.model';
import { CommonService } from 'src/app/services/common.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import endpoints from 'src/app/helpers/endpoints';
import * as moment from 'moment';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';

@Component({
  selector: 'fury-partners-list',
  templateUrl: './partners-list.component.html',
  styleUrls: ['./partners-list.component.scss'],
  animations: [fadeInUpAnimation, fadeInRightAnimation, scaleInAnimation],
  encapsulation: ViewEncapsulation.None
})
export class PartnersListComponent implements OnInit, OnDestroy {
  selectConfig = {disableOptionCentering: true,panelClass: 'custom-class'}
  columns: any[] = [
    { name: 'Name', property: 'title', visible: true },
    { name: 'Utm Source', property: 'utmSource', visible: true },
    { name: 'Api Key', property: 'apiKey', visible: true },
    { name: 'Source', property: 'referralAbbreviation', visible: true },
    { name: 'Phone', property: 'phoneNumber', visible: true },
    { name: 'Url', property: 'url', visible: true },
    { name: 'Webhook URL', property: 'thirdPartyWebhookUrl', visible: true },
    { name: 'Status', property: 'isActive', visible: true },
    { name: 'Actions', property: 'actions', visible: true }
  ];
  partnerList: any;
  filterValue = 'Lead Partners';
  dataSource: MatTableDataSource<any[]> = new MatTableDataSource<any[]>([]);
  pageIndex: number = 0;
  searchedKeyword: string = '';
  pageSize: number = 30;
  totalCount: number = 0;
  searchBy: string = 'title';
  searchType: string = 'contains';
  isShowFilter: boolean = false;
  partnerDashboardData: any = {};
  ngUnSubscribe = new Subject<void>();

  filterForm = new FormGroup<FilterFormModal>({
    searchBy: new FormControl(this.searchBy),
    searchType: new FormControl(this.searchType),
  });
  dateRangePickerForm = new FormGroup({
    start: new FormControl<Date | null>(null),
    end: new FormControl<Date | null>(null),
  });
  today = new Date();
  startDate: null|string = null;
  endDate: null|string = null;
  constructor(
    private api: ApiService,
     private dialog: MatDialog,
     private activatedRoute: ActivatedRoute,
     private router: Router,
     public commonService: CommonService
     ) { }

  ngOnInit(): void { 
    this.activatedRoute.queryParams.pipe(takeUntil(this.ngUnSubscribe)).subscribe((res: any) => {
      this.pageIndex = res.page ? res.page - 1 : 0;
      this.searchedKeyword = res.keywords ? res.keywords : '';
      this.pageSize = res.size ? (res.size === 'all' ? 9999 : res.size) : 30;  
      this.searchBy = res.searchBy ? res.searchBy : 'title';
      this.searchType = res.searchType ? res.searchType : 'contains';
      this.filterForm.patchValue({
        searchBy: this.searchBy,
        searchType: this.searchType
      });       
    });
    this.getPartner();
    this.getLeadPartnerDashboardData();
   }

  
   pageSizeChange(event: any) {    
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.router.navigateByUrl(`/lead-partners/partner-list?page=${this.pageIndex + 1}${this.searchedKeyword ? '&keywords=' + this.searchedKeyword : ''}${this.pageSize ? '&size=' + (this.pageSize === 9999 ? 'all' : this.pageSize) : ''}&searchBy=${this.searchBy}&searchType=${this.searchType}`);
    this.getPartner();
  }

  onFilterChange(value: any) {
    if (!this.dataSource) { return } else {
      this.pageIndex = 0;
      this.searchedKeyword = value.trim(); this.getPartner();
      this.router.navigateByUrl(`/lead-partners/partner-list?page=${this.pageIndex + 1}${this.searchedKeyword ? '&keywords=' + this.searchedKeyword : ''}${this.pageSize ? '&size=' + (this.pageSize === 9999 ? 'all' : this.pageSize) : ''}&searchBy=${this.searchBy}&searchType=${this.searchType}`);
     }
  }
  openDialog(type: string, id: string){
    const dialogref = this.dialog.open(ContentActionComponent, { width: '500px', data: { type } });
    dialogref.afterClosed().subscribe((res: Confirmation) => {
      if (res === Confirmation.Yes) {
        this.api.delete(endpoints.leadPartner.deleteLeadPartner(id)).pipe(takeUntil(this.ngUnSubscribe)).subscribe({
          next: (del: any) => {
            if (del.body) {
              this.api.alert(del.body.message, ErrorType.Success);
              this.getPartner();
            }
          }, error: (err: HttpErrorResponse) => {
            if (err) {
              this.api.alert(ErrorText.SomeThingWentWrong, ErrorType.Error);
            }
          }
        });
      }
    });
  }
  getPartner() {
    this.api.get(`${endpoints.leadPartner.getLeadPartnerList}?page=${this.pageIndex + 1}&size=${this.pageSize}${this.searchedKeyword ? '&keywords=' + this.searchedKeyword : ''}&searchBy=${this.searchBy}&searchType=${this.searchType}`).pipe(takeUntil(this.ngUnSubscribe)).subscribe({
      next: (res: HttpResponse<any>) => {
        if (res.status === 200) {
            this.partnerList = res.body['leadPartners']['data'];
            this.totalCount = res.body['leadPartners']['total']
            this.dataSource = new MatTableDataSource(res.body['leadPartners']['data']);            
        }
      }
    });
  }
  get visibleColumns() {
    return this.columns.filter(column => column.visible).map(column => column.property);
  }

  showFilter(){
    this.isShowFilter = !this.isShowFilter; 
  }
  serchByValue: any[] = [
    {title: 'Title', value: 'title'},
    {title: 'Utm Source', value: 'utmSource'},
    {title: 'Api Key', value: 'apiKey'},
    {title: 'Referral Abbreviation', value: 'referralAbbreviation'},
    {title: 'Phone Number', value: 'phoneNumber'},
    {title: 'Url', value: 'url'},
  ];
  filterChange(){
    this.searchType = this.filterForm.value.searchType;
    this.searchBy = this.filterForm.value.searchBy;
    this.router.navigateByUrl(`/lead-partners/partner-list?page=${this.pageIndex + 1}${this.searchedKeyword ? '&keywords=' + this.searchedKeyword : ''}${this.pageSize ? '&size=' + (this.pageSize === 9999 ? 'all' : this.pageSize) : ''}&searchBy=${this.searchBy}&searchType=${this.searchType}`);
    this.isShowFilter = false;
    this.getPartner();
  }
  getLeadPartnerDashboardData(){
    this.api.get(`${endpoints.leadPartner.getLeadpartnerDashboard}${this.startDate ? '?startDate=' + this.startDate : ''}${this.endDate ? '&endDate=' + this.endDate: ''}`).pipe(takeUntil(this.ngUnSubscribe)).subscribe({
      next: (res: HttpResponse<any>)=>{
        if(res.body){
          this.partnerDashboardData = res.body?.data;
        }
      },
      error: (err: HttpErrorResponse)=>{
        this.api.alert(err.error?.message, ErrorType.Error);
      }
    })
  }
  dateRangeChangeHandle(dateRangeStart: HTMLInputElement, dateRangeEnd: HTMLInputElement){
    if(this.dateRangePickerForm.valid){
      if(this.dateRangePickerForm.value.start && !this.dateRangePickerForm.value.end){
        this.dateRangePickerForm.markAllAsTouched();
        return;
      }
      this.startDate = this.dateRangePickerForm.value.start? moment(this.dateRangePickerForm.value.start).format('YYYY-MM-DD HH:mm:ss'): null;
      this.endDate = this.dateRangePickerForm.value.end ? moment(this.dateRangePickerForm.value.end).format('YYYY-MM-DD HH:mm:ss'): null;
     this.getLeadPartnerDashboardData();
    }
  };
  clearDaterangePicker(){
    if(this.dateRangePickerForm.value.start){
      this.dateRangePickerForm.patchValue({
        start: null,
        end: null,
      });
      this.startDate = null;
      this.endDate = null;
      this.getLeadPartnerDashboardData();
    }
    
  }
  changeLeadPartnerStatus(event: MatSlideToggleChange, row: any) {
    let data: any;
    data = { isActive: event.checked };
    this.api
      .patch(
        endpoints.leadPartner.changeLeadPartnerStatus(row?.leadPartnerId), data
      ).pipe(takeUntil(this.ngUnSubscribe))
      .subscribe(
        (res: any) => {
          if (res.body) {
            this.api.alert(res.body.message, ErrorType.Success);
          }
        },
        (err: HttpErrorResponse) => {
          if (err) {
            row.isActive = !row.isActive;
              this.api.alert(err.message, ErrorType.Error);
          }
        }
      );
  }
  ngOnDestroy(): void {
    this.ngUnSubscribe.next();
    this.ngUnSubscribe.complete();
  }

}
